export function getAnchorNavIdFromTitle(title) {
    if (!title) {
        return undefined;
    }
    return title
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9\-]/g, '');
}
